import { login } from '@/api/user';
import { getInfo } from '@/api/power-cable-auth/account'
import { setToken, removeToken, getToken } from "../mutation-types"
import { EventBus } from '@/utils/vueBus';
import { logout } from '@/api/power-cable-auth/user';
const state = {
  token: '',
  username: '',
  userInfo: {}
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, { username }) => {
    state.username = username
  },
  SET_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    state.username = userInfo.nickName
    state.avatar = userInfo.avatar
  }
}
const actions = {
  login({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: account.trim(), password: password }).then(response => {
        if (response.code == '200' || response.code == '0') {
          if (!response.extras.actived) {
            resolve(response)
          } else {
            const { data } = response;
            setToken(data);
            commit('SET_TOKEN', data)
            resolve(response)
            EventBus.$emit('mySocketEvent')
          }
        } else {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const data = response.data
        if (response.code !== 0) {
          reject('Verification failed, please Login again.')
        }
        const { name } = data;
        commit('SET_INFO', data);
        commit('SET_NAME', { username: name });
        resolve(data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  logout ({ commit, dispatch }) {
    logout().then((res) => {
      if (res.code == 0) {
        dispatch('resetToken')
        location.reload()
      }
    }).catch(() => {})
  },
  // remove token
  resetToken({ commit }) {
    commit('SET_INFO', '');
    commit('SET_NAME', '');
    commit('SET_TOKEN', '')
    removeToken();
    EventBus.$emit('stopMySocketEvent')
  },
}
const getters = {
  userInfo(state) {
    return state.userInfo
  },
  // 是否个体户
  companyType: (state) => state.userInfo?.company?.type == 7,
  companyId: (state) => state.userInfo?.company?.id,
  token: () => state.token||getToken()

}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
